import {
  Button, Dialog, DialogActions,
  DialogContent, DialogContentText, DialogTitle,
} from '@mui/material';
import { useState } from 'react';

export const useConfirm = (title: string, message: string, okOnly: boolean = false) => {
  const [promise, setPromise] = useState<{
    resolve: (value: unknown) => void
  } | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const confirm = () => new Promise((resolve, reject) => {
    setPromise({ resolve });
  });

  const handleClose = () => {
    setPromise(null);
  };

  const handleConfirm = () => {
    promise?.resolve(true);
    handleClose();
  };

  const handleCancel = () => {
    promise?.resolve(false);
    handleClose();
  };

  // You could replace the Dialog with your library's version
  const ConfirmationDialog = () => (
    <Dialog
      open={promise !== null}
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {okOnly ? (
            <Button onClick={handleConfirm}>OK</Button>
        ) : (
            <>
              <Button onClick={handleConfirm}>Yes</Button>
              <Button onClick={handleCancel}>Cancel</Button>
            </>
        )}
      </DialogActions>
    </Dialog>
  );
  return {
    dialog: ConfirmationDialog,
    confirm
  };
};